import { ValidationProps } from 'ui';
import { CodeActionType } from 'app/area/indicator-factors/item/types';
import { CodetableAccess, CodetableMetadataState } from 'app/area/indicator-factors/types-store';
import { CodetableOptions } from 'app/area/indicator-factors/common';
import { CodetableTranslation } from 'app/area/indicator-factors/constants';
import { LoadCodetableOptions } from 'app/area/indicator-factors/item/types';
import { CodeListItem, CodeListModifiedItem, CodetableListState,
  LoadCodeParametersPayload } from 'app/area/indicator-factors/list/types-store';
import { AccessCodes, AccessCodetables, CodetableMetadata } from 'app/area/indicator-factors/types-store';
import { SearchFiltersExternalProps } from 'app/area/search-filters/types';
import { LoadOptions } from 'app/types-shared';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export enum IndicatorFactorsPicker {
  validFrom = 'validFrom',
  location = 'location',
  unit = 'unit',
  source = 'source',
  equipment = 'equipment'
}

interface CodetableListCommonProps {
  codetableId: number;
  codeId: number;
  breadcrumbs: number[];
  modifiedItems: CodeListModifiedItem[];
  validation: { [key: string]: ValidationProps };
  fetchingDelete: number;
  fetchingData: boolean;
  translation: CodetableTranslation;
  locale: string;
  loadMoreData: (searchModel: FilterSearchModel, startIndex: number) => void;
  deleteCodeItem: (codetableId: number, codeId: number, successMessage: string) => void;
  modifyItem: (modifiedItem: CodeListModifiedItem) => void;
  saveChanges: () => void;
  cancelChanges: () => void;
}

export interface CodetableListItemsProps extends CodetableListCommonProps {
  requestId?: number;
  requestedSearchModel?: FilterSearchModel;
  data?: CodeListItem[];
  numberOfResults?: number;
  metadata: CodetableMetadata;
  codetableAccess: CodetableAccess;
  itemAccesses: AccessCodes[];
}

export interface CodetableListComponentProps extends CodetableListCommonProps, SearchFiltersExternalProps {
  category: CodeComplexValue<number>;
  metadata: CodetableMetadata;
  shouldRenderList: boolean;
  shouldRenderSpinLoader: boolean;
  codetableOptions: { [key: string]: CodetableOptions };
  hasSelectedCategory: boolean;
  hasCategoryMetadata: boolean;
  codetableAccess: CodetableAccess;
  itemAccesses: AccessCodes[];
  codetableItemAccess?: AccessCodetables;
  requestedSearchModel?: FilterSearchModel;
  data?: CodeListItem[];
  numberOfResults?: number;
  isFetching?: boolean;
  fetchingCodetableId: number;
  updating: boolean;
  loadCodetableOptions: (id: string, codetableId: number, loadOptionsParams: LoadOptions) => void;
}

export interface CodetableSelectorProps {
  breadcrumbs: number[];
  codeId: number;
  parentId: number;
  categoryId: number;
  actionType: CodeActionType;
  shouldPrompt?: boolean;
}

export interface DuplicateRowsComponentProps {
  list: CodetableListState;
  metadata?: CodetableMetadataState;
  locale: string;
  translation: CodetableTranslation;
  validation: { [key: string]: ValidationProps };
  onClose: () => void;
  save: () => void;
  updateByKey: (key: IndicatorFactorsPicker, value: CodeComplexValue<number> | Date) => void;
  resetValidation: (key: string) => void;
  loadCodetableOptions: LoadCodetableOptions;
  loadCodeParameters: (payload: LoadCodeParametersPayload) => void;
  updateIsDirty: (value: boolean) => void;
}

export interface DuplicateRowsFieldProps {

  list?: CodetableListState;
  translation?: CodetableTranslation;
  locale: string;
  validation: { [key: string]: ValidationProps };
  updateByKey: (key: IndicatorFactorsPicker, value: CodeComplexValue<number> | Date) => void;
  resetValidation: (key: string) => void;
  loadCodetableOptions?: LoadCodetableOptions;
  updateIsDirty: (value: boolean) => void;
}

export interface DeleteRowsComponentProps {
  fetchingDeleteRows: boolean;
  numberOfResults: number;
  translation: CodetableTranslation;
  onClose: () => void;
  save: () => void;
}
